import { themeStore } from '@neptune/shared/theme-domain';

import { applyTheme } from './apply-theme';

/** @note: expected to be invoked from app initialization code */
export const initializeTheme = () => {
  applyTheme(document.documentElement, themeStore.getTheme());
};
